import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FindLoad } from 'utils';
import { Loader } from 'components';
import { resourceActions } from 'store';
import { SingleResource } from './fragments';
import { GET_SINGLE_ACTION_TYPE } from './constants';

export const ResourceById = ({}) => {
    const loader = FindLoad(GET_SINGLE_ACTION_TYPE);
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
        dispatch(resourceActions.getResourceById(params?.id));
    }, [dispatch]);

    if (loader?.length) {
        return <Loader />;
    }

    return (
        <div>
            <SingleResource />
        </div>
    );
};
